// 9fbef606107a605d69c0edbcd8029e5d
import addCustomerAddress from '@tcp/core/src/queries/addCustomerAddress.query.graphql';
import updateCustomerAddress from '@tcp/core/src/queries/updateCustomerAddress.query.graphql';
import addUpdateMaillingAddress from '@tcp/core/src/queries/addUpdateMaillingAddress.query.graphql';
import { executeStatefulGraphQLQuery } from '../../handler';
import { parseBoolean } from '../../../utils';
import logger from '../../../utils/loggerInstance';

export const addAddress = (args) => {
  const payload = {
    address1: args.address1,
    address2: args.address2,
    c_addressType: 'ShippingAndBilling',
    c_emailId: args.email || args.emailAddress,
    c_validationCode: args.validationCode || '',
    stateCode: args.state || args.stateCode || '',
    city: args.city,
    countryCode: args.country || args.countryCode || '',
    firstName: args.firstName,
    lastName: args.lastName,
    phone: args.phoneNumber,
    postalCode: args.zip || args.zipCode || args.postalCode || '',
    preferred: parseBoolean(args.preferred),
  };
  if (args?.phoneCountryCode) {
    payload.c_phoneCountryCode = args.phoneCountryCode;
  }
  return executeStatefulGraphQLQuery({
    query: addCustomerAddress,
    variables: {
      addCustomerAddressAddressRequestDto: payload,
    },
    type: 'mutation',
  })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      throw err;
    });
};

export const updateAddress = (args) => {
  let body = {
    address1: args.address1 || args.addressLine1 || '',
    address2: args.address2 || args.addressLine2 || '',
    c_addressType: 'ShippingAndBilling',
    c_emailId: args.email || args.emailAddress,
    stateCode: args.state || args.stateCode,
    c_validationCode: args.validationCode || '',
    city: args.city,
    preferred: args.preferred,
    countryCode: args.country || args.countryCode,
    firstName: args.firstName,
    lastName: args.lastName,
    phone: args.phoneNumber,
    postalCode: args.zip || args.zipCode || args.postalCode || '',
  };
  if (args?.phoneCountryCode) {
    body.c_phoneCountryCode = args.phoneCountryCode;
  }
  if (args.checkoutUpdateOnly) {
    body = {
      addressId: args.addressId,
      fromPage: 'checkout',
    };
  }
  return executeStatefulGraphQLQuery({
    query: updateCustomerAddress,
    variables: {
      updateCustomerAddressAddressRequestDto: body,
      updateCustomerAddressAddressId: args.addressId,
    },
    type: 'mutation',
  })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      throw err;
    });
};

export const addUpdateMailingAddress = (args) => {
  const body = {
    address1: args.address1 || args.addressLine1 || '',
    address2: args.address2 || args.addressLine2 || '',
    c_addressType: 'Mailing',
    c_emailId: args.email || args.emailAddress,
    stateCode: args.state || args.stateCode,
    c_validationCode: args.validationCode || '',
    city: args.city,
    preferred: parseBoolean(args.preferred),
    countryCode: args.country || args.countryCode,
    firstName: args.firstName,
    lastName: args.lastName,
    phone: args.phoneNumber,
    addressId: args.addressId,
    postalCode: args.zip || args.zipCode || args.postalCode || '',
  };
  return executeStatefulGraphQLQuery({
    query: addUpdateMaillingAddress,
    variables: {
      addressRequestDto: body,
    },
    type: 'mutation',
  })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      throw logger.error('Mailing Address', 'Error in adding/updating mailing address', err);
    });
};
